import { z } from 'zod';

export const LANGUAGES = ['en', 'fr'] as const;
export const languageSchema = z.enum(LANGUAGES);
export type LanguageCode = z.infer<typeof languageSchema>;
